var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20459 16.5C1.65459 16.5 1.18392 16.3043 0.79259 15.913C0.401257 15.5217 0.205257 15.0507 0.20459 14.5V2.5C0.20459 1.95 0.40059 1.47933 0.79259 1.088C1.18459 0.696666 1.65526 0.500667 2.20459 0.5H18.2046C18.7546 0.5 19.2256 0.696 19.6176 1.088C20.0096 1.48 20.2053 1.95067 20.2046 2.5V14.5C20.2046 15.05 20.0089 15.521 19.6176 15.913C19.2263 16.305 18.7553 16.5007 18.2046 16.5H2.20459ZM10.2046 9.5L18.2046 4.5V2.5L10.2046 7.5L2.20459 2.5V4.5L10.2046 9.5Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5d8403b639b514f162262e7a6260c98e.svg";
export { ForwardRef as ReactComponent };